(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-sale-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    var SELECTOR = '[data-cart-sale-countdown]';

    function pad(value) {
      var n = Math.max(0, Math.floor(value));
      return n < 10 ? '0' + n : String(n);
    }

    function setValue(root, key, value) {
      var node = root.querySelector('[data-countdown-' + key + ']');
      if (node && node.textContent !== value) {
        node.textContent = value;
      }
    }

    function render(root) {
      var endAttr = root.getAttribute('data-countdown-end');
      var endTime = Date.parse(endAttr);

      if (isNaN(endTime)) {
        root.hidden = true;
        return false;
      }

      var diff = (endTime - Date.now()) / 1000;

      if (diff <= 0) {
        root.hidden = true;
        return false;
      }

      setValue(root, 'days', pad(diff / 86400));
      setValue(root, 'hours', pad((diff % 86400) / 3600));
      setValue(root, 'minutes', pad((diff % 3600) / 60));
      setValue(root, 'seconds', pad(diff % 60));

      root.hidden = false;
      return true;
    }

    function start(root) {
      if (root.dataset.countdownInitialised === 'true') return;
      root.dataset.countdownInitialised = 'true';

      if (!render(root)) return;

      var timer = setInterval(function () {
        if (!render(root)) {
          clearInterval(timer);
        }
      }, 1000);
    }

    function init() {
      var nodes = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        start(nodes[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    /* The cart drawer is re-rendered after AJAX cart updates in this theme, so
       re-initialise whenever the drawer markup changes. */
    document.addEventListener('cart:updated', init);
    document.addEventListener('cart:build', init);
    document.addEventListener('shopify:section:load', init);

    if (window.MutationObserver) {
      var observeTarget = document.getElementById('CartDrawer') || document.body;
      if (observeTarget) {
        new MutationObserver(function () {
          init();
        }).observe(observeTarget, { childList: true, subtree: true });
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
